export const environment = {
  production: false,
  apiUrl: 'https://api.dev.juboo.baamtuservices.com/api'
};
